export const arrayToObjectById = (array, idKey = 'id') =>
  array.reduce((acc, item) => {
    return { ...acc, [item[idKey]]: item }
  }, {})
